<template>
    <a-modal
        :visible="true"
        width="40vw"
        :footer="null"
        :closable="false"
        :destroy-on-close="true"
        centered
        wrap-class-name="pwm-wrap"
        @cancel="close()"
    >
        <div class="pwm-modal">
            <div class="pwm-head">
                <div>
                    <h3>Alterar embalagem</h3>
                    <div class="pwm-sub">{{ product.descricaoProduto }}</div>
                </div>
                <button class="pwm-x" @click="close()">
                    <span class="material-icons-outlined">close</span>
                </button>
            </div>

            <cc-loader-full v-if="loading" />
            <div class="pwm-body" v-else>
                <div class="pwm-field" v-if="!isGenericFlow">
                    <label class="pwm-label">Embalagem</label>
                    <a-select
                        :value="wrap ? wrap.value : undefined"
                        placeholder="Selecione"
                        class="pwm-input"
                        @change="onWrapChange"
                    >
                        <a-select-option v-for="option in wraps" :key="option.value" :value="option.value">
                            {{ option.name }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="pwm-field">
                    <label class="pwm-label">{{ isGenericFlow ? "Quantidade na embalagem" : "Quantidade" }}</label>
                    <a-input
                        v-model="amount"
                        class="pwm-input"
                        inputmode="decimal"
                        placeholder="0"
                        :disabled="isFixedAmount"
                        @input="handleAmountInput"
                        @pressEnter="update_wrap"
                    />
                </div>
            </div>

            <div class="pwm-foot">
                <a-button @click="close()">Cancelar</a-button>
                <a-button type="primary" :loading="loading" @click="update_wrap">Atualizar</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import ProductService from "@/services/v2/products.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import QuotationService from "@/services/QuotationService";

const FIXED_AMOUNTS = { UN: "1", DZ: "12" };

export default {
    name: "ProductWrapModalV2",
    props: ["product", "salesman"],
    mixins: [loaderMixin],
    data() {
        return {
            service: new ProductService(),
            loading: false,
            wrap: null,
            amount: null,
            wraps: [
                { name: "Atado", value: "AT" },
                { name: "Unidade", value: "UN" },
                { name: "Caixa", value: "CX" },
                { name: "Fardo", value: "FD" },
                { name: "Quilo", value: "KG" },
                { name: "Display", value: "DP" },
                { name: "Duzia", value: "DZ" },
                { name: "Pacote", value: "PC" },
            ],
        };
    },
    computed: {
        isGenericFlow() {
            return !!(this.product.flag_generico || this.product.pro_principal);
        },
        isFixedAmount() {
            return !!(this.wrap && FIXED_AMOUNTS[this.wrap.value]);
        },
    },
    watch: {
        "wrap.value": function (new_val) {
            if (FIXED_AMOUNTS[new_val]) {
                this.amount = FIXED_AMOUNTS[new_val];
            }
        },
    },
    methods: {
        onWrapChange(value) {
            this.wrap = this.wraps.find((option) => option.value === value) || null;
        },
        handleAmountInput(event) {
            let value = event.target.value.replace(/[^0-9.]/g, "");
            const [integer, ...decimals] = value.split(".");
            value = decimals.length ? `${integer}.${decimals.join("").slice(0, 3)}` : integer;

            this.amount = value;
            event.target.value = value;
        },
        close(value) {
            this.$emit("close", value);
        },
        update_wrap() {
            if (!this.amount) {
                this.snack('Por favor, insira um valor para o campo "quantidade".', "error");
                return;
            }
            this.loading = true;
            if (this.isGenericFlow) {
                this.service = new QuotationService();
                this.service
                    .update_quotation_typing({
                        seller_id: this.salesman.idVendedor,
                        quotation_id: this.$route.params.id,
                        provider_id: this.salesman.idFornecedor,
                        product_id: this.salesman.pro_id || this.product.idProduto,
                        quantidade_digitacao: this.amount,
                    })
                    .then(() => {
                        this.$set(this.salesman, "embalagem", this.amount);
                        this.$set(this.product, "quantidadeDigitacao", this.amount);
                        this.close();
                    });
            } else {
                const payload = { wrap: `${this.wrap.value} ${this.amount}` };
                this.service
                    .update_wrap(this.product.idProduto, payload)
                    .then((response) => response.data)
                    .then(() => this.$set(this.product, "embalagem", payload.wrap))
                    .then(() => this.$set(this.product, "qtd_embalagem", this.amount))
                    .then(() => this.close(payload))
                    .catch((error) => {
                        this.loading = false;
                        ErrorHandlerService.handle(error, this.$store);
                    });
            }
        },
    },
    created() {
        if (this.isGenericFlow) {
            if (this.product.flag_generico) this.amount = this.salesman.embalagem;
            else this.amount = this.product.quantidadeDigitacao;
        } else {
            const [unit, amount] = this.product.embalagem.split(" ");
            this.amount = amount;
            this.wrap = { name: unit, value: unit };
        }
    },
};
</script>

<style lang="scss" scoped>
.pwm-modal {
    max-height: 82vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.pwm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        margin: 0;
    }
}
.pwm-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.pwm-x {
    width: 28px;
    height: 28px;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f0f0f0;
        color: #262626;
    }
}
.pwm-body {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 16px 20px;
    border-top: 1px solid #f0f0f0;
}
.pwm-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 180px;
}
.pwm-label {
    font-size: 13px;
    color: #595959;
}
.pwm-input {
    width: 100%;
}
.pwm-foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.pwm-wrap {
    .ant-modal {
        min-width: 480px;
        max-width: 720px;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
